<!--
  升级问诊流程，替换IM组件
-->
<template>
  <div class="chatHome">
    <h2 class="title-area">
      <div class="title">
        <span class="main-title">咨询详情</span>
        <div class="btn">
          <el-button
            size="small"
            class="closeConsult"
            :class="{ 'el-icon-switch-button': status === 'start' }"
            @click="closeConsult"
          >
            {{ status === 'end' || status === 'done' ? '返回' : '结束咨询' }}
          </el-button>
        </div>
      </div>
      <breadcrumb firstName="咨询列表"></breadcrumb>
    </h2>
    <div class="box">
      <template>
        <zim-pc-inquiry>
          <template #header>
            <template>
              <div></div>
            </template>
          </template>
          <template #message>
            <div class="hint-wrapper">
              <div class="hint">
                根据国家互联网医院管理办法要求，平台仅为复诊患者提供服务。为了保障您的用药安全，购买该药物需要经过医生问诊，请根据真实情况回答，并请仔细阅读
                <a target="_blank" :href="`${host}/web/im-drugstore/assets/智云健康医疗服务知情同意协议书.html`">
                  《互联网医院诊疗风险告知书及知情同意书》
                </a>
                ，继续咨询即表示您已知悉相关规则与风险并同意相关条款。
              </div>
            </div>
          </template>
          <template #tools-bar>
            <div class="bar-item" v-if="showStartVideo" @click="handlerStartVideo">
              <i class="icon el-icon-video-camera"></i>
            </div>
          </template>
        </zim-pc-inquiry>
      </template>
    </div>
    <el-dialog :visible.sync="showPrescriptionUrl" width="375px">
      <div class="dialog__warp">
        <img class="close" :src="require('@/assets/img/icon_close.png')" alt="" @click="showPrescriptionUrl = false" />
        <iframe v-if="showPrescriptionUrl" :src="prescriptionUrl" width="100%" height="100%" frameborder="0"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumb from '@/components/global/breadcrumb';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { zimPcInquiry } from '@zyf2e/zim-ecology/lib/pc';
import Fetch from '@/api';
import { getDevHost, getStatic, Util } from '@/util';
import { CONSULT_TYPE } from '@/pages/chooseConsultType/constants';
// import zim, { emojis, GuideDiagnosisClass, tools, zimApi } from '@zyf2e/zim/lib/drugPlatform';
export default {
  name: 'chatSession',
  components: { breadcrumb, zimPcInquiry },
  computed: {
    ...mapGetters({
      Inquiry: 'imInquiryService/getInquiry',
      EcologyEvent: 'imService/getEcologyEvent',
      vsPubSub: 'video_trtcVideoStore/getVsPubSub',
      vsEvent: 'video_trtcVideoStore/getVsEvent'
    }),
    ...mapState('video', ['isStartLocalCamera']),
    host() {
      return getStatic();
    },
    // 是否显示发起视频
    showStartVideo() {
      const {
        advisoryInfo: { advisoryType },
        isStartLocalCamera
      } = this;
      if (advisoryType == CONSULT_TYPE.VIDEO_CONSULT) {
        // 没有视频正在进行中
        if (!isStartLocalCamera) return true;
      }
      return false;
    }
  },
  data() {
    return {
      id: null,
      status: 'start',
      showPrescriptionUrl: false,
      advisoryInfo: {},
      prescriptionInfo: {}
    };
  },
  created() {
    // this.initIMConfig();
  },
  mounted() {
    Telescope.trackEvent({
      trackId: 'zywzpc-chatSession-1',
      custom: {
        advisoryId: this.$route.params.advisoryId,
        path: this.$route.path
      }
    });

    this.id = this.$route.params.advisoryId;
    this.init();
    this.$store.dispatch('imInputService/SET_UseEmoj', true);
  },
  beforeRouteLeave(to, from, next) {
    /**
     * 从聊天页面切换到其它任何页面时
     */
    next();
  },
  methods: {
    ...mapActions('socket', ['im_prescription']),
    ...mapMutations('nwVideo', ['SET_NW_VIDEO', 'SET_PRESCRIPTION_INFO', 'SET_SHOW_DRUG_DIALOG']),
    closeConsult() {
      const { advisoryType } = this.advisoryInfo;
      const { status } = this.$route.query;

      if (this.status === 'start') {
        this.$confirm('确定要结束本次咨询吗')
          .then(() => {
            Fetch.close_advisory(this.id).then(() => {
              this.$router.push(`/chooseConsultType/applyPrescription/${advisoryType}`);
            });
          })
          .catch(() => {});
      } else if (this.status === 'end') {
        if (status === 'history') {
          this.$store.dispatch('tagsView/delView', { name: 'applyPrescription', meta: { title: '' } }).then(() => {
            this.$router.push(`/chooseConsultType/applyPrescription/${advisoryType}`);
          });
        } else {
          this.$router.push(`/chooseConsultType/applyPrescription/${advisoryType}`);
        }
      } else {
        this.$router.push('/chooseConsultType');
      }

      Telescope.trackEvent({
        trackId: 'zywzpc-click--IM-Close'
      });
    },
    handleVideo(url) {
      this.$alert(`<video width="300px" height="300px" src="${url}" controls></video>`, {
        center: true,
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        callback: (action, instance) => {
          instance.$el.parentNode.removeChild(instance.$el);
        }
      });
    },
    async init() {
      Telescope.trackEvent({
        trackId: 'zywzpc-chatSession-2',
        custom: {
          advisoryId: this.$route.params.advisoryId
        }
      });
      const data = await Fetch.getPrescriptionByAdvisoryId({ advisoryId: this.id });
      Telescope.trackEvent({
        trackId: 'zywzpc-chatSession-3',
        custom: {
          advisoryId: this.id
        }
      });
      await this.$store.dispatch('imInquiryService/SET_advisory_id', this.id);
      if (Object.keys(data).length > 0) {
        const { doctorAuditStatus, imGroupId, advisoryStatus, advisoryType } = data;

        if (
          doctorAuditStatus === 1 ||
          doctorAuditStatus === 2 ||
          doctorAuditStatus === 4 ||
          advisoryStatus === 'REJECT'
        ) {
          // 视频消息，需要禁言（历史需求）
          if (advisoryType === CONSULT_TYPE.VIDEO_CONSULT) {
            await this.$store.dispatch('imInquiryService/SET_ISEND', true);
          }
        }

        // doctorAuditStatus 0待确认,1确认通过,2驳回，4超时
        if (doctorAuditStatus === 1) {
          this.status = 'done';
        } else if (doctorAuditStatus === 4 || doctorAuditStatus === 2) {
          this.status = 'end';
        }

        if (advisoryStatus === 'REJECT') {
          this.status = 'end';
        }

        this.advisoryInfo = data;

        if (imGroupId) {
          this.getImPrescription(imGroupId);
        }
      }
      await this.$store.dispatch('imChatService/SET_CHATHEADERCONFIG', {
        chatHeaderConfig: {
          // 头部模块配置化
          avatarShow: false
        }
      });
      this.$nextTick(async () => {
        const { doctorAuditStatus, imGroupId } = data;

        this.Inquiry.startInquiry();

        if (imGroupId) {
          const historyMessage = await Fetch.getMessageList({
            groupId: imGroupId,
            limit: 50,
            nextToken: '',
            receiverUId: this.$store.getters.ucUserId
          });

          /**
           * 不初始化im情况
           * 有finish
           * 医生状态为1、2、4    （通过、驳回、取消）
           * 咨询单总时长 > 2小时（咨询单两小时失效）
           */
          if (historyMessage.data?.length > 0) {
            const finishMsg = historyMessage.data.find(o => o.messageType === 'Finish');

            if (finishMsg) {
              return;
            }

            if (doctorAuditStatus === 1 || doctorAuditStatus === 2 || doctorAuditStatus === 4) {
              return;
            }

            if (new Date() - historyMessage.data[0].createTime > 2 * 60 * 60 * 1000) {
              return;
            }
          }
        }

        // this.connectIM();
      });

      this.EcologyEvent.unsubscribe('imMessageService.onRichlink');
      this.EcologyEvent.subscribe('imMessageService.onRichlink', (tag, { message }) => {
        const {
          messageInfo: {
            body: { linkAddress }
          }
        } = message;

        this.showPrescriptionUrl = true;
        this.prescriptionUrl = `${linkAddress.replace(/^(http:|https:)/, '')}?autoInit=true`;
      });
      this.EcologyEvent.unsubscribe('imMessageService.drugPlatform_video');
      this.EcologyEvent.subscribe('imMessageService.drugPlatform_video', (tag, { message }) => {
        const {
          messageInfo: {
            body: { text }
          }
        } = message;

        this.handleVideo(text);
      });

      this.EcologyEvent.unsubscribe('imService.onmessageTargetGroup');
      this.EcologyEvent.subscribe('imService.onmessageTargetGroup', (tag, { messageInfo }) => {
        if (messageInfo.type === 'Finish') {
          const { advisoryType } = this.advisoryInfo;
          if (advisoryType === CONSULT_TYPE.VIDEO_CONSULT) {
            this.$store.dispatch('imChatService/SET_taskUserCanspeak', false);
          }

          Fetch.getPrescriptionByAdvisoryId({ advisoryId: this.id }).then(data => {
            const { doctorAuditStatus, advisoryStatus } = data;
            if (doctorAuditStatus === 1) {
              this.status = 'done';
            } else if (doctorAuditStatus === 4 || doctorAuditStatus === 2) {
              this.status = 'end';
            }

            if (advisoryStatus === 'REJECT') {
              this.status = 'end';
            }
          });
        }
      });

      this.EcologyEvent.unsubscribe('imInquiryService.exitAdvisory');
      this.EcologyEvent.subscribe('imInquiryService.exitAdvisory', (tag, data) => {
        const { advisoryType } = this.advisoryInfo;
        Fetch.close_advisory(this.id).then(() => {
          this.$router.push(`/chooseConsultType/applyPrescription/${advisoryType}`);
        });
      });
    },
    getImPrescription(groupId) {
      return this.im_prescription(groupId).then(prescriptionInfo => {
        const { url, doctorId } = prescriptionInfo;
        this.initNWVideo(prescriptionInfo);
        this.prescriptionInfo = prescriptionInfo;
        url && (this.prescriptionUrl = `${url.replace(/^(http:|https:)/, '')}?autoInit=true`);
        return doctorId;
      });
    },
    async initNWVideo(prescriptionInfo) {
      const { id: prescriptionId, advisoryType, status } = prescriptionInfo;
      this.SET_PRESCRIPTION_INFO(prescriptionInfo);
      if (advisoryType != CONSULT_TYPE.VIDEO_CONSULT || status === '已失效' || status === '已驳回') {
        this.SET_NW_VIDEO(false);
        return;
      }
      let res = await Fetch.check_append_details_and_connected({ pid: prescriptionId });
      this.SET_NW_VIDEO(!res.alreadyAppendDetails && !res.alreadyConnected);
      if (res.alreadyConnected && !res.alreadyAppendDetails) {
        // 发起过视频 但未填药
        this.$store.commit('video/SET_SHRINK', true);
        this.SET_SHOW_DRUG_DIALOG(true);
      }
    },

    async handlerStartVideo() {
      // 音视频操作: 在IM页面点击视频发起的音视频通话 店员->医生
      const { imGroupId: groupId } = this.advisoryInfo;
      const { doctorId, doctorName, patientName, prescriptionId } = this.prescriptionInfo;
      const { userName, ucUserId } = this.$store.state.global.userInfo;
      const custom = {
        callName: userName,
        groupId,
        message: `${userName}邀请你进行视频`,
        groupTitle: `${patientName}的用药咨询`,
        prescriptionId,
        videoFrom: 'DOCTOR'
      };
      this.$store.dispatch('video_trtcVideoStore/loginTRTCAccount', {});
      setTimeout(() => {
        if (doctorId) {
          this.$store.dispatch(
            'video_controller/makeCall',
            {
              contactId: doctorId.toString(),
              business: custom,
              bizNo: prescriptionId,
              scene: 'DRUGSTORE_PATIENT_TO_DOCTOR'
            },
            { root: true }
          );
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.chatHome {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box {
  display: flex;
  flex: 1;
  // background: #fafafa;
  overflow: hidden;
  position: relative;
  background: #fff;
}

.hint-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;

  .hint {
    padding: 4px 20px;
    width: 784px;
    background: #eeeeee;
    border-radius: 4px;
    font-size: 12px;
    white-space: normal;
    text-align: left;
    box-sizing: border-box;
    line-height: 18px;
    color: #8c8c8c;
    a {
      color: #1e8dff;
    }
  }
}

/deep/.el-dialog {
  .el-dialog__body {
    padding: 0 20px;
  }
  .dialog__warp {
    width: 100%;
    height: 600px;
    .close {
      position: absolute;
      width: 13px;
      height: 13px;
      top: 12px;
      right: 12px;
      z-index: 2;
    }
  }
}

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon {
  font-size: 16px;
}
</style>
